// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QUoM","label":"styles_label__3P48o"};